import type { TranslatedNames } from "@/modules/eventDetails/client/api/types"
import type { I18nLocale } from "@/modules/i18n/types"

import { DEFAULT_LOCALE } from "@/modules/locales/constants"

export const getTranslationFromLocale = (translations: TranslatedNames, locale: I18nLocale): string => {
  const hasUserLocale = typeof translations[locale] !== "undefined"
  const hasDefaultLocale = typeof translations[DEFAULT_LOCALE] !== "undefined"

  if (Object.keys(translations).length === 0) {
    console.error("Event campus name is not provided")
    return "N/A"
  }

  if (hasUserLocale) {
    const campus = translations[locale] as string
    return campus
  }

  if (!hasUserLocale && hasDefaultLocale) {
    const campus = translations[DEFAULT_LOCALE] as string
    return campus
  }

  return Object.values(translations)[0]
}
